import React, {useMemo} from 'react';

import {Auth0Provider, Auth0ProviderOptions} from '@auth0/auth0-react';

import {DEFAULT_AUTHENTICATION_CONFIG} from './authentication-context';

type Props = {
    authConfig: typeof DEFAULT_AUTHENTICATION_CONFIG,
    children: React.ReactElement,
};

const DEFAULT_SCOPE = 'openid profile email';

const toAuth0DomainFromIssuerUri = (issuerUri?: string) => {
    if (!issuerUri) {
        return '';
    }
    try {
        const url = new URL(issuerUri);
        return url.host;
    } catch {
        return '';
    }
};

export const Auth0AuthenticationEnvironment: React.FC<Props> = ({children, authConfig}) => {
    const auth0Config = useMemo(() => {
        const config: Auth0ProviderOptions = {
            domain: authConfig.domain || toAuth0DomainFromIssuerUri(authConfig.issuerUri),
            clientId: authConfig.clientId || '',
            authorizationParams: {
                redirect_uri: window.location.origin + authConfig.callback,
                scope: DEFAULT_SCOPE,
                source: 'bus0155',
            },
            useRefreshTokens: true,
            useRefreshTokensFallback: true,
            useFormData: true,
            cacheLocation: 'localstorage',
        };

        return config;
    }, [authConfig]);

    if (!auth0Config.domain || !auth0Config.clientId) {
        return null;
    }

    return (
        <Auth0Provider {...auth0Config}>
            {children}
        </Auth0Provider>
    );
};
